import React, { useEffect, useRef } from 'react';
import { motion, useAnimation, useInView, Variants } from 'framer-motion';

export const AnimateOnScroll = ({ children, className = '', delay = 0, variants }: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  variants?: Variants
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [isInView, controls]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={variants || {
        hidden: { opacity: 0, y: 0 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
            ease: 'easeOut',
            delay: delay
          }
        }
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
